import React from "react";

function IllustrationRdcMatchingBuyers() {
  return (
    <svg
      width="129"
      height="96"
      viewBox="0 0 129 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.5 42C72.232 42 78.5 35.732 78.5 28C78.5 20.268 72.232 14 64.5 14C56.768 14 50.5 20.268 50.5 28C50.5 35.732 56.768 42 64.5 42ZM71.5 24.8267L62.8929 34C61.5447 32.4983 57.5 28.3465 57.5 28.3465L60.1965 25.5198L62.8929 28.3465L68.8035 22L71.5 24.8267Z"
        className="fill-primary"
      />
      <path
        d="M31.4 63.6899C31.4 67.3275 34.4 70.3589 38 70.3589C24.5 70.3589 24.5 78.2404 24.5 84H51.5C51.5 78.2404 51.5 70.3589 38 70.3589C41.6 70.3589 44.6 67.3275 44.6 63.6899C44.6 60.0523 41.6 57 38 57C34.4 57 31.4 59.7491 31.4 63.6899Z"
        className="fill-secondary"
      />
      <path
        d="M58.4 63.6899C58.4 67.3275 61.4 70.3589 65 70.3589C51.5 70.3589 51.5 78.2404 51.5 84H78.5C78.5 78.2404 78.5 70.3589 65 70.3589C68.6 70.3589 71.6 67.3275 71.6 63.6899C71.6 60.0523 68.6 57 65 57C61.4 57 58.4 59.7491 58.4 63.6899Z"
        className="fill-secondary"
      />
      <path
        d="M85.4 63.6899C85.4 67.3275 88.4 70.3589 92 70.3589C78.5 70.3589 78.5 78.2404 78.5 84H105.5C105.5 78.2404 105.5 70.3589 92 70.3589C95.6 70.3589 98.6 67.3275 98.6 63.6899C98.6 60.0523 95.6 57 92 57C88.4 57 85.4 59.7491 85.4 63.6899Z"
        className="fill-secondary"
      />
    </svg>
  );
}

export default IllustrationRdcMatchingBuyers;
